import { AxiosResponse } from 'axios';
import { IRestTotalReq } from '../rKeeperApi/types';
import { api, API_URL } from '@api/config';
import {
    IInventedItems,
    ILike4Like,
    IPosition,
    IReportAbc,
    IReportAverageCheckByDay,
    IReportCountChecksByDay,
    IReportRestByDay,
    ISourcesData,
} from '@entities/reports';
import { IDateRangeType } from '@types';

const BASE_PATH = 'shops';

export const getRestRevenueByDaylRequest = (
    shop_id: number,
    params: IRestTotalReq
): Promise<AxiosResponse<IReportRestByDay>> => {
    return api.get<IReportRestByDay>(
        `${API_URL}/${BASE_PATH}/${shop_id}/reports/revenue/restaurant/total/sum`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getTopPositionRequest = (
    shop_id: number,
    params: IRestTotalReq
): Promise<AxiosResponse<IPosition[]>> => {
    return api.get<IPosition[]>(`${API_URL}/${BASE_PATH}/${shop_id}/menu/top`, {
        params: {
            ...params,
        },
    });
};
export const getInventedItemsRequest = (
    shop_id: number
): Promise<AxiosResponse<IInventedItems[]>> => {
    return api.get<IInventedItems[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/inventedCategory/items`
    );
};

export const getStopPositionRequest = (
    shop_id: number,
    params: IRestTotalReq
): Promise<AxiosResponse<IPosition[]>> => {
    return api.get<IPosition[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/menu/stop`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getCountChecksByDaylRequest = (
    shop_id: number,
    params: IRestTotalReq
): Promise<AxiosResponse<IReportCountChecksByDay>> => {
    return api.get<IReportCountChecksByDay>(
        `${API_URL}/${BASE_PATH}/${shop_id}/reports/revenue/restaurant/total/checks`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getAverageCheckByDaylRequest = (
    shop_id: number,
    params: IRestTotalReq
): Promise<AxiosResponse<IReportAverageCheckByDay>> => {
    return api.get<IReportAverageCheckByDay>(
        `${API_URL}/${BASE_PATH}/${shop_id}/reports/revenue/restaurant/total/avgcheck`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getLike4LikeRequest = (
    shop_id: number,
    params: IRestTotalReq
): Promise<AxiosResponse<ILike4Like>> => {
    return api.get(
        `${API_URL}/${BASE_PATH}/${shop_id}/reports/revenue/restaurant/like4like`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getAbcRequest = (
    shop_id: number,
    params: IRestTotalReq
): Promise<AxiosResponse<IReportAbc>> => {
    return api.get<IReportAbc>(
        `${API_URL}/${BASE_PATH}/${shop_id}/reports/abc`,
        {
            params: {
                ...params,
            },
        }
    );
};
export const getSourcesRequest = (
    shop_id: number,
    params: IDateRangeType
): Promise<AxiosResponse<ISourcesData>> => {
    return api.get<ISourcesData>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/sources`,
        {
            params: {
                ...params,
            },
        }
    );
};
